import { Injector } from "@angular/core";
import { AuthService } from "../../../../service/auth-service/auth-service.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeAuthorisedProduct } from "../Entity/TreeNodeAuthorisedProduct";
import { TreeNodeDrugIndication } from "../Entity/TreeNodeDrugIndication";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeDrugsIndicationsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Drug Indications ({param})');
      this.labelNodeName = 'Drug Indications';
      this.parent = parent;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeDrugIndication(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeDrugsIndicationsList =
        new TreeNodeDrugsIndicationsList(this.ioc!, newParent);
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    override getMessage(): any {
      let productindications: Art57Node[] = [];
      this.children?.forEach((node) => {
        let productindication = node as Art57Node;
        productindications.push(productindication.getMessage());
      });
      if (productindications.length > 0) {
        return { productindications: { productindication: productindications } };
      } else {
        return undefined;
      }
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if (this.parent instanceof TreeNodeAuthorisedProduct) {
        if ((!this.ioc!.get(AuthService).isEMAOrganisation()) &&
            (!this.children || this.children.length == 0)) {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.bussinessValidationError,
            controlId: undefined,
            controlLabel: '',
            error: 'Section is Mandatory',
          });
        } else {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.errorInactive,
            controlId: undefined,
            controlLabel: '',
            error: '',
          });
        }
      }
  
      return errors;
    }
  
    override getHeaders(): string[] {
      return ['Meddra Version', 'Meddra Level', 'Meddra Term'];
    }
  }

